import React, { useState, useLayoutEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Status from '@/types/Status.type';
import StatusService from '@/services/Status.service';
import { useSnackbar } from 'notistack';
import { Messages } from '@/common/constants';
import Loading from '@/components/common/Loading';
import CommonTableContainer from '@/components/common/CommonTableContainer';
import ConfirmDialog from '@/components/common/ConfirmDialog';
import { Box, Button, Grid } from '@mui/material';
import PageTitle from '@/components/common/PageTitle';
import StatusTableBody from '@/components/statuses/StatusTableBody';
import StatusTableBodyPlan0 from '@/components/statuses/StatusTableBodyPlan0';
import URL from '@/common/routes/Url';

import CompanyService from '@/services/Company.service';

type DeleteType = {
  id: number;
  statusName: string;
};

const StatusList: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [statuses, setStatuses] = useState<Array<Status>>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState<DeleteType>({ id: 0, statusName: '' });

  const [contPlan, setContPlan] = useState(0);

  const getStatuses = useCallback(() => {
    StatusService.getAll({ params: { sortKey: 'id' } })
      .then((response) => {
        setStatuses(response.data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        enqueueSnackbar(Messages.select.failure);
      });
  }, []);

  useLayoutEffect(() => {
    
    // 会社マスタ取得
    CompanyService.get().then((response: { data: any }) => {
      setContPlan(response.data.contPlan);
    });

    getStatuses();
    
  }, []);

  const deleteStatus = async (id: number) => {
    try {
      await StatusService.delete(id);
    } catch (error: any) {
      enqueueSnackbar(error.response.data.message);
      return;
    }
    enqueueSnackbar(Messages.delete.success, { variant: 'info' });
    getStatuses();
  };

  const editStatus = (id: number) => {
    navigate(`${URL.statuses}/${id}/`);
  };

  const createStatus = () => {
    navigate(`${URL.statuses}/add`);
  };

  const handleDialog = (id: number, statusName: string) => {
    setDeleteInfo({
      id: id,
      statusName: statusName,
    });
    setIsOpen(true);
  };
  const statusTableHeads = [
    'ステータス名',
    '略名',
    'アイコン',
    /*'カラー',*/
    '表示順',
    '戻り時間必須',
    '簡易登録利用',
    '',
  ];

  const statusTableHeadsPlan0 = [
    'ステータス名',
    '略名',
    'アイコン',
    /*'カラー',*/
    '表示順',
    '戻り時間必須',
    '',
  ];

  const statusTableBody = <StatusTableBody onEdit={editStatus} onDelete={handleDialog} rows={statuses} />;
  const statusTableBodyPlan0 = <StatusTableBodyPlan0 onEdit={editStatus} onDelete={handleDialog} rows={statuses} />;
  if (isLoading) {
    return <Loading />;
  }
  return (
    <>
      <Grid container justifyContent="center">
        <Grid item xs={12} lg={8}>
          <Box sx= {{ display: { xs: 'block', sm: 'none' } }}>
            <PageTitle>ステータスマスタ</PageTitle>
          </Box>
          <Box sx={{ marginBottom: '16px' }}>
            <Button variant="contained" color="primary" onClick={() => createStatus()}>
              追加画面へ
            </Button>
          </Box>
          {contPlan === 1 ?
          <CommonTableContainer tableHeads={statusTableHeads} tableBody={statusTableBody} />
          : 
          <CommonTableContainer tableHeads={statusTableHeadsPlan0} tableBody={statusTableBodyPlan0} />
        }
        </Grid>
      </Grid>
      <ConfirmDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onOk={() => {
          setIsOpen(false);
          deleteStatus(deleteInfo.id);
        }}
      >
        {deleteInfo.statusName}を本当に削除しますか？
      </ConfirmDialog>
    </>
  );
};
export default StatusList;
